import { render, staticRenderFns } from "./empty.vue?vue&type=template&id=7c18521b&scoped=true"
import script from "./empty.vue?vue&type=script&lang=js"
export * from "./empty.vue?vue&type=script&lang=js"
import style0 from "./empty.vue?vue&type=style&index=0&id=7c18521b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c18521b",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Theme2DesktopNavBar: require('/app/components/Theme2/Desktop/NavBar.vue').default,Theme2MobileNavBar: require('/app/components/Theme2/Mobile/NavBar.vue').default,CommonsChangeLanguageLoading: require('/app/components/Commons/ChangeLanguageLoading.vue').default})
